import { render, staticRenderFns } from "./ZGLogicDetail.vue?vue&type=template&id=487f527b&scoped=true&"
import script from "./ZGLogicDetail.vue?vue&type=script&lang=js&"
export * from "./ZGLogicDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZGLogicDetail.vue?vue&type=style&index=0&id=487f527b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f527b",
  null
  
)

export default component.exports